import { render, staticRenderFns } from "./ShippingPhasesInWarehouse.vue?vue&type=template&id=13f34be3"
import script from "./ShippingPhasesInWarehouse.vue?vue&type=script&lang=js"
export * from "./ShippingPhasesInWarehouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports